import api from 'api/api';
import downloadReceipt from 'utils/downloadReceipt';
import { IAccountLookup, ILocalLookupRes, ITransferCharge } from './ToFirstAtlantic.model';

export const lookupLocalAccount = (accountNumber: string): Promise<IAccountLookup> =>
  api
    .get<ILocalLookupRes>(`transfer/lookupaccount?accountNumber=${accountNumber}`)
    .then((data) => ({ name: data.accountName, beneficiaryId: undefined, currency: data.accountCurrency }
    ));

export const getReceipt = (transactionID: number) =>
  api.get(`/transaction/receipt?trnxID=${transactionID}`).then(downloadReceipt);

export const getTransferCharge = (amount: string | number) =>
  api.get<ITransferCharge>(`transfer/otherbank/charge?amount=${amount}`);
